import { forwardRef } from 'react'
import { Search as SearchIcon, X as XIcon } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

import { cn } from '@/helpers/utils'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const SearchInput = forwardRef(({ onChange, onSearch, onClear, value, className, placeholder = 'Search', ...props }, ref) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch()
    }
  }

  return (
    <div className={twMerge('min-w-[300px]', className)}>
      <div className='flex w-full items-center'>
        <div className='relative flex-grow'>
          <Input
            type='text'
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            ref={ref}
            className={cn('rounded-r-none', value ? 'pr-10' : '', 'w-full')}
            {...props}
          />
          <If condition={value}>
            <XIcon
              onClick={onClear}
              className='absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground hover:text-foreground cursor-pointer'
            />
          </If>
        </div>
        <Button className='rounded-l-none border-l-0 h-[40px]' variant='outline' onClick={onSearch} type='button'>
          <SearchIcon size={16} />
        </Button>
      </div>
    </div>
  )
})

export default SearchInput
